/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getGlobal = require("../../getGlobal");
var globalObject = (0, _getGlobal.getGlobal)();
var DEFAULTS = {
  duration: 100,
  orientation: 'vertical'
};
var _default = function _default(node, newValue, config, callback) {
  if (typeof config === 'function') {
    callback = config;
    config = null;
  }
  if (!config) {
    config = DEFAULTS;
  }
  var _config = config,
    orientation = _config.orientation;
  var _config2 = config,
    duration = _config2.duration;
  var horiz = orientation == 'horizontal';
  var scrollPosName = horiz ? 'scrollLeft' : 'scrollTop';
  var currentValue = node[scrollPosName];
  var diff = newValue - currentValue;
  var now = Date.now();
  duration = duration != null ? duration : 100;
  var millisecondStep = diff / duration;
  if (!duration) {
    node[scrollPosName] = newValue;
    if (typeof callback === 'function') {
      callback(newValue);
    }
    return;
  }
  var scroll = function scroll() {
    var elapsed = Date.now() - now;
    node[scrollPosName] = currentValue + elapsed * millisecondStep;
    if (elapsed < duration) {
      globalObject.requestAnimationFrame(scroll);
    } else {
      node[scrollPosName] = newValue;
      if (typeof callback === 'function') {
        callback(newValue);
      }
    }
  };
  globalObject.requestAnimationFrame(scroll);
};
exports.default = _default;